<mat-drawer-container autosize>
  <mat-drawer mode="side" class="nav-sidebar" [opened]="items()?.length > 1" [class.is-open]="contentsOpen">
    <div class="sidebar-wrap">
      @if ('research.portal.fulldisplay.file.contents' | translate; as contentsLabel) {
        <div class="title-wrap">
          <button
            mat-icon-button
            class="contents-toggle-btn"
            (click)="handleContentsToggle()"
            color="primary"
                    [attr.aria-label]="
                        'research.portal.fulldisplay.details.' + (contentsOpen ? 'collapseSection' : 'showSection')
                            | translate: { val0: contentsLabel }
                    "
            >
            @if (contentsOpen) {
              <mat-icon
                class="mat-icon-rtl-mirror"
                svgIcon="chevron-double-left"
                muloSvgViewbox
              ></mat-icon>
            }
            @if (!contentsOpen) {
              <mat-icon
                class="mat-icon-rtl-mirror"
                svgIcon="chevron-double-right"
                muloSvgViewbox
              ></mat-icon>
            }
          </button>
          <h2 class="title">{{ contentsLabel }}&nbsp;({{ items()?.length }})</h2>
          <button
            mat-icon-button
            class="next-prev-btn"
            (click)="handleItemButtonClick(currentIdx - 1)"
            [disabled]="currentIdx == 0"
            [attr.aria-label]="'research.search.results.next' | translate"
            >
            <mat-icon svgIcon="chevron-up" muloSvgViewbox></mat-icon>
          </button>
          <button
            mat-icon-button
            class="next-prev-btn"
            (click)="handleItemButtonClick(currentIdx + 1)"
            [disabled]="currentIdx == items()?.length - 1"
            [attr.aria-label]="'research.search.results.previous' | translate"
            >
            <mat-icon svgIcon="chevron-down" muloSvgViewbox></mat-icon>
          </button>
        </div>
      }

      @if (contentsOpen) {
        <div class="sidebar-content">
          @for (item of items(); track item; let i = $index) {
            <button
              (click)="handleItemButtonClick(i)"
              class="item-button has-shadow"
              [color]="currentIdx == i ? 'primary' : undefined"
              mat-raised-button
              >
              <div class="item-button-content">
                @if (item.isResricted) {
                  <mat-icon
                    class="thumbnail"
                    svgIcon="lock"
                    muloSvgViewbox
                  ></mat-icon>
                } @else {
                  @if (item.thumbnail) {
                    <img [src]="item.thumbnail | safeUrl" class="thumbnail" alt="" />
                  }
                }
                <ng-template #thumbnail>
                  @if (item.thumbnail) {
                    <img [src]="item.thumbnail | safeUrl" class="thumbnail" alt="" />
                  }
                </ng-template>
                <span>{{ item.label }}</span>
              </div>
            </button>
          }
        </div>
      }
    </div>
  </mat-drawer>
  <mat-drawer-content class="content">
    @if (items()?.[currentIdx]; as currentItem) {
      <div class="title-wrap">
        @if (currentItem.label) {
          <h2 class="title" id="item-title">{{ currentItem.label }}</h2>
        }
        @if (media.is('gt-md')) {
          @if (!isStandalone() && enableStandalone()) {
            <a
              role="button"
              mat-raised-button
              class="has-icon margin-right-xs"
              routerLink="filesAndLinks"
              [relativeTo]="route"
              queryParamsHandling="merge"
              [queryParams]="{ index: currentIdx }"
              target="_blank"
              >
              <mat-icon class="mat-icon-rtl-mirror" svgIcon="open-in-new" muloSvgViewbox></mat-icon>
              <span>{{ 'research.portal.fulldisplay.file.viewerStandaloneBtn' | translate }}</span>
            </a>
          }
          @if (
            currentItem.downloadUrl &&
            !currentItem.isResricted &&
            currentItem.contentType &&
            currentItem.contentType !== 'ESPLORO_LINK'
            ) {
            <a
              role="button"
              mat-raised-button
              class="has-icon"
              [href]="currentItem.downloadUrl"
              target="_blank"
              >
              <mat-icon svgIcon="download"></mat-icon>
              <span>{{ 'research.portal.fulldisplay.file.download' | translate }}</span>
            </a>
          }
        } @else {
          @if (!isStandalone() && enableStandalone()) {
            <a
              role="button"
              mat-icon-button
              class="margin-right-xs"
              routerLink="filesAndLinks"
              [relativeTo]="route"
              queryParamsHandling="merge"
              [queryParams]="{ index: currentIdx }"
              target="_blank"
              [attr.aria-label]="'research.portal.fulldisplay.file.viewerStandaloneBtn' | translate"
              >
              <mat-icon class="mat-icon-rtl-mirror" svgIcon="open-in-new" muloSvgViewbox></mat-icon>
            </a>
          }
          @if (
            currentItem.downloadUrl &&
            !currentItem.isResricted &&
            currentItem.contentType &&
            currentItem.contentType !== 'ESPLORO_LINK'
            ) {
            <a
              role="button"
              mat-icon-button
              [href]="currentItem.downloadUrl"
              target="_blank"
              [attr.aria-label]="'research.portal.fulldisplay.file.download' | translate"
              >
              <mat-icon svgIcon="download" muloSvgViewbox></mat-icon>
            </a>
          }
        }
      </div>
      @if (currentItem.isResricted) {
        <div class="restricted">
          <img src="assets/images/no-access-rights.svg" alt="" class="margin-sm" />
          <p class="margin-md">{{ 'research.portal.fulldisplay.access.closed' | translate }}</p>
        </div>
      } @else {
        @if (currentItem.url) {
          <mulo-arcview
            [src]="currentItem.url"
            [alt]="currentItem.label"
            [type]="currentItem.contentType"
            [loadingText]="'research.portal.fulldisplay.file.loading' | translate"
            [unsupportedMsg]="'research.portal.fulldisplay.file.unsupported' | translate"
            [errorMsg]="'research.portal.fulldisplay.errorStatus.unknown' | translate"
            ariaLabelledBy="item-title"
          ></mulo-arcview>
        }
      }
    }
    @if (!items()?.[currentIdx]) {
      <mulo-loading-slate height="100%"></mulo-loading-slate>
    }
    @if (!items()?.[currentIdx]) {
      <p class="loading-text">
        {{ 'research.portal.fulldisplay.file.loading' | translate }}
      </p>
    }
  </mat-drawer-content>
  @if (isStandalone()) {
    <mat-drawer
      mode="side"
      position="end"
      opened
      class="details-sidebar"
      [class.is-open]="detailsOpen"
      >
      <div class="sidebar-wrap">
        @if ('research.portal.fulldisplay.section.details' | translate; as detailsLabel) {
          <div class="title-wrap">
            <button
              mat-icon-button
              class="details-toggle-btn"
              (click)="handleDetailsToggle()"
              color="primary"
                    [attr.aria-label]="
                        'research.portal.fulldisplay.details.' + (detailsOpen ? 'collapseSection' : 'showSection')
                            | translate: { val0: detailsLabel }
                    "
              >
              @if (detailsOpen) {
                <mat-icon
                  class="mat-icon-rtl-mirror"
                  svgIcon="chevron-double-right"
                  muloSvgViewbox
                ></mat-icon>
              }
              @if (!detailsOpen) {
                <mat-icon
                  class="mat-icon-rtl-mirror"
                  svgIcon="chevron-double-left"
                  muloSvgViewbox
                ></mat-icon>
              }
            </button>
            <h2 class="title">{{ detailsLabel }}</h2>
          </div>
        }
        @if (detailsOpen) {
          <mulo-dictionary
            alignLabels="left"
            display="column"
            class="sidebar-content"
            tabindex="0"
            >
            @for (line of assetDetails(); track line) {
              <div mulo-dictionary-item [label]="line.label">
                @for (element of line.value; track $index) {
                  <ng-container slot="content">
                    @if ((element | translate) === '') {
                      <div [innerHTML]="element | htmlEscape: false"></div>
                    } @else {
                      <div [innerHTML]="element | translate | htmlEscape: false"></div>
                    }
                  </ng-container>
                }
              </div>
            }
          </mulo-dictionary>
        }
      </div>
    </mat-drawer>
  }
</mat-drawer-container>
